export default __webpack_public_path__ + "static/media/44e2b693923816415ee52099ceff5dba.svg";